package com.anjuros.website.templates.template2.modules


import com.anjuros.website.templates.template2.util.ResKey

enum class Template2Achievement(
    val number: ResKey,
    val text: ResKey
) {

    EXPERIENCE(
        number = ResKey.TEMPLATE2_ACHIEVEMENT1_NUMBER,
        text = ResKey.TEMPLATE2_ACHIEVEMENT1
    ),

    PROJECTS(
        number = ResKey.TEMPLATE2_ACHIEVEMENT2_NUMBER,
        text = ResKey.TEMPLATE2_ACHIEVEMENT2
    ),

    CUSTOMERS(
        number = ResKey.TEMPLATE2_ACHIEVEMENT3_NUMBER,
        text = ResKey.TEMPLATE2_ACHIEVEMENT3
    ),

    RATING(
        number = ResKey.TEMPLATE2_ACHIEVEMENT4_NUMBER,
        text = ResKey.TEMPLATE2_ACHIEVEMENT4
    )

}